import React, { useState } from "react";
import { isValidUrl } from "../../utils/main";
import axios from "@dreamchimney/react-axios";
import { useHistory } from "react-router-dom";

import AddStep1 from "./AddStep1";
import AddStep2 from "./AddStep2";
import { LOCAL_STORE_JWT } from "../../utils/main";
import { useUser } from "@dreamchimney/user-context";
import { addSleeve, getSleeveFavorites } from "../../api/getSleeves";

const AddSleevePage = (props) => {
  let history = useHistory();
  const { state: userState, dispatch } = useUser();
  const [step, setStep] = useState(1);
  const [sleeve, setSleeve] = useState({});
  const [hasError, setHasError] = useState(false);

  const handleChangeExtUrl = (event) => {
    const ext_url = event.target.value; // ext_url is used in backend
    setHasError(!isValidUrl(ext_url));
    setSleeve({ ...sleeve, ext_url });
  };
  const convertToBase64 = (file) => {
    return new Promise((resolve, reject) => {
      const fileReader = new FileReader();
      fileReader.readAsDataURL(file);
      fileReader.onload = () => {
        // Important to remove the data:image/png;base64, from the base64
        resolve(fileReader.result.split(",")[1]);
      };
      fileReader.onerror = (error) => {
        reject(error);
      };
    });
  };

  const handleUploadImage = async (event) => {
    const file = event.target.files[0];
    const img_upload_url = URL.createObjectURL(file);

    const base64 = await convertToBase64(file);

    setSleeve({ ...sleeve, img_upload: { base64 }, img_upload_url });
  };

  const gotoStep2 = () => setStep(2);

  const handleCancel = () => {
    history.push(`/`);
  };

  const handleSubmit = (payload = {}) => {
    const jwt = localStorage.getItem(LOCAL_STORE_JWT) || false;
    payload = { ...payload, jwt, chimdir: userState.user.dir };

    if (!jwt || !payload.artist || !payload.title || (payload.tags && payload.tags.length === 0)) {
      setHasError(true);
    } else {
      setHasError(false);

      // submit sleeve
      console.log("submit payload result:", payload);
      return addSleeve(axios, payload);
    }
  };

  return (
    <div className="page-add">
      <form className="form-horizontal" name="sleeveForm" id="sleeveForm" role="form" noValidate action="javascript:;" autoComplete="off">
        <h1>Add Sleeve</h1>

        {hasError && <div className=" alert alert-danger">Something looks wrong here, please check the errors in red below.</div>}

        {step === 1 && (
          <AddStep1
            sleeve={sleeve}
            hasError={hasError}
            gotoStep2={gotoStep2}
            handleChangeExtUrl={handleChangeExtUrl}
            handleUploadImage={handleUploadImage}
          />
        )}
        {step === 2 && <AddStep2 sleeve={sleeve} handleSubmit={handleSubmit} handleCancel={handleCancel} />}
      </form>

      <div className="instructions" ng-show="step1">
        <h3>Please Read Before Posting</h3>

        <ul>
          <li>Only files of the type PNG or JPG are accepted.</li>
          <li>
            <b>Please use good judgement before uploading any images that could potentially be offensive or obscene</b>.
          </li>
          <li>
            Try to make sure the image you are adding IS NOT already on the site.
            <ul>
              <li>
                If you have a better quality image of an existing sleeve{" "}
                <a href="mailto:dreamchimney@gmail.com?subject=New Sleeve">email it</a>.
              </li>
            </ul>
          </li>
          <li>If possible, crop the image to create a square size sleeve, it will look much better.</li>
          <li>Please keep the file size of your image down to less then 2 MB.</li>
          <li>NOTE: If the sleeve is boring or just not cool, it will be quietly removed by an admin. Thanks!</li>
        </ul>
      </div>
    </div>
  );
};
export default AddSleevePage;
